export const environment = {
  production: true,
  baseUrl: 'https://api.limitlesscare.com/',
  publicKey: `-----BEGIN PUBLIC KEY-----
MIIBCgKCAQEAwYZvWUx94Fw95tZsRcT7bucu6ZiD1SlBy5u0TwDMQ/eIQENZtmdrUHTTzM3TDWr+dj89oE4EfUy5qG+nzDrFxlD/9O92m8hBh3vXyJzO6QaJdCqa/Ecuzfrl+SoANnLQ9qkrh/U2hQlxBkQtc21dL/OCkCsxdo3TJJxtUY14MSPEo4Bc8XVgnN8444ddPpaDtNmqvOV8rZT+Wc1hae+4lAUCQq5AgDWJyfP+SSJN2fb00l7cDEzjmUVwRH8fWrsRXstlMrBl4hm5wiIKkKt/oXyucfC/xXUSJM77owlM1CPnw1Yf4Jdem4VaB/nqhQ/ezEbrl7JEnMRIvore2DPg6QIDAQAB
-----END PUBLIC KEY-----`,
sentryDsn: 'https://8de4fc31269a34818a56d1aad643e49d@o4509055687524352.ingest.de.sentry.io/4509943822745680'

};
export const baseUrl = 'https://api.limitlesscare.com/';
